import { socket, getSocketConnectionData } from '@speechki-frontend/core/socket';
import { getToken } from '@speechki-frontend/core/auth/utils';

import { splitBookpart as apiSplitBookpart } from '../api/bookpart';

const TIMEOUT_LENGTH = 20000;
const ERROR_MESSAGE = [
    {
        detail: 'Generation error, please try again'
    }
];

/**
 * Splits sentence into several with websocket response and timeout fallback
 * @param {*} bpId
 * @param {*} sentences
 * @param {*} callback
 * @returns
 */
export const splitBookpart = async (bpId, sentences, callback = () => {}) => {
    let promiseResolve,
        promiseReject,
        timeout,
        ids = [];
    window.onbeforeunload = () => {
        clearTimeout(timeout);
    };

    const response = await apiSplitBookpart(bpId, sentences);

    // remove pause ids (every other)
    ids = response.extra_data.new_book_part_ids.filter((id, index) => {
        return index % 2 == 0;
    });

    const ws = socket(getSocketConnectionData(getToken()));

    ws.receiver.on('record_process_book_part_update', handleMessage);

    const off = () => {
        ws.receiver.on('record_process_book_part_update', handleMessage);
    };

    async function handleMessage({ code, params }) {
        if (code !== 200) {
            off();
            return promiseReject(ERROR_MESSAGE);
        }

        if (params.action === 'split') {
            const responseIds = params.extra_data.bp_ids;

            if (isEqual(ids, responseIds)) {
                if (params.is_completed) {
                    off();
                    return promiseResolve();
                }

                await callback(params);
            }
        }
    }

    return new Promise((resolve, reject) => {
        promiseResolve = resolve;
        promiseReject = reject;

        timeout = setTimeout(() => {
            return promiseResolve();
        }, TIMEOUT_LENGTH);
    });
};

const isEqual = (ar1, ar2) => {
    return ar1.every(item => {
        return ar2.includes(item);
    });
};
